import { types } from "mobx-state-tree";

import { MenuItems } from "../../../components/secondary-menu/SecondaryMenu";
import {
  ViewSewerObject,
  ViewSewerObjectFromAssignedProject,
} from "../../../services/authorization/Permissions";
import { permissionsService } from "../../../services/authorization/UserPermissionsService";

export enum StructureDynamicMenuItemsPages {
  EditStructure,
}

export const StructureMenuItemsModel = types
  .model({
    structureId: types.number,
    editMode: types.optional(types.boolean, false),
    dynamicMenuItemPage: types.maybe(types.frozen<StructureDynamicMenuItemsPages>()),
    parentIdFromPath: types.number,
    shouldDisableMenuItems: types.optional(types.boolean, false),
  })
  .actions((self) => {
    return {
      getStaticMenuItems(): MenuItems {
        return {
          "general.general": {
            items: [
              {
                id: "secondary-menu-structure-details",
                labelKey: "general.structure.details",
                path: `/${self.parentIdFromPath}/sewer-objects/structure/${self.structureId}`,
                canAccess: permissionsService.userHasOneOfThePermissions([
                  ViewSewerObject,
                  ViewSewerObjectFromAssignedProject,
                ]),
                isActive: self.dynamicMenuItemPage === StructureDynamicMenuItemsPages.EditStructure,
                disabled: self.shouldDisableMenuItems,
              },
              {
                id: "secondary-menu-structure-map",
                labelKey: "general.sewer-objects.map",
                path: `/${self.parentIdFromPath}/sewer-objects/structure/${self.structureId}/map`,
                canAccess: permissionsService.userHasOneOfThePermissions([
                  ViewSewerObject,
                  ViewSewerObjectFromAssignedProject,
                ]),
                disabled: self.shouldDisableMenuItems,
              },
              {
                id: "secondary-menu-linked-objects",
                labelKey: "general.linked-objects",
                path: `/${self.parentIdFromPath}/sewer-objects/structure/${self.structureId}/linked-objects`,
                canAccess: permissionsService.userHasOneOfThePermissions([
                  ViewSewerObject,
                  ViewSewerObjectFromAssignedProject,
                ]),
                disabled: self.shouldDisableMenuItems,
              },
            ],
            defaultOpen: true,
          },
        };
      },
    };
  });
